/**
 * Pet Mindful · Acordeón
 *
 * El atributo name en <details> ya agrupa los items en navegadores nuevos,
 * pero Safari y Firefox viejos lo ignoran. Esto cierra los demás a mano para
 * que la regla «uno abierto a la vez» se cumpla en todos.
 *
 * La ficha carga este archivo dos veces (contenido y FAQ); la clase vive
 * dentro del if para que la segunda carga no la vuelva a declarar.
 */
if (!customElements.get('pm-accordion')) {
  class PMAccordion extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('details'));

      this.items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;
          this.items.forEach((other) => {
            if (other !== item) other.open = false;
          });
        });
      });
    }
  }

  customElements.define('pm-accordion', PMAccordion);
}
